import { ReactNode, useContext } from 'react';
import styled from 'styled-components';

import { variableFontRegular } from 'styles/theme';

import { TabValue, TabsContext } from 'shared/providers/TabsProvider';

export interface ITabUIProps {
  className?: string;
  children?: ReactNode;
  active: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

export const TabUI = ({ className, active = false, children, ...rest }: ITabUIProps) => (
  <TabUI.Root className={`${active ? 'active' : ''} ${className}`} {...rest}>
    {children}
    {active && <TabUI.ActiveBar className="tab_active-bar" />}
  </TabUI.Root>
);

TabUI.Root = styled.button`
  ${variableFontRegular({ height: '14px', size: '11.5px' })}
  padding: 16px 8px;
  position: relative;
  text-align: center;
`;

TabUI.ActiveBar = styled.div`
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 2px;
  background: currentcolor;
  max-width: 109px;
  margin-inline: auto;
`;

export interface ITabProps {
  className?: string;
  children?: ReactNode;
  value: TabValue;
  disabled?: boolean;
}

export const Tab = ({ className, value, ...rest }: ITabProps) => {
  const { value: contextValue, setValue } = useContext(TabsContext);
  return (
    <TabUI
      className={`tab ${className}`}
      {...rest}
      active={contextValue === value}
      onClick={() => setValue(value)}
    />
  );
};
